<div class="container">
  <div class="banner" [ngStyle]="{ 'background-color': toasterConfig.containerColor }">
    <div class="icon-container">
      @if (svgIcon && svgIcon !== '') {
        <mat-icon class="main-icon-svg" [svgIcon]="svgIcon"></mat-icon>
      }
      @if (icon && icon !== '') {
        <mat-icon class="main-icon">{{ icon }}</mat-icon>
      }
    </div>
    <div class="message" [ngStyle]="{ color: toasterConfig.fontColor }">
      {{ message }}
    </div>
    <div class="cancel-button-container">
      <button mat-button class="cancel-button" (click)="onClose()">
        <mat-icon [ngStyle]="{ color: toasterConfig.fontColor }" class="close-icon">close</mat-icon>
      </button>
    </div>
  </div>
</div>
